module.exports = "../img/Lupa.svg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Lupa.svg
// module id = 60
// module chunks = 0